import config from '@/config';
import Generator from '@/webApi/generator'
export default new Generator({
     //获取用户OpenId
     get_OpenId: { url: '/WeChart/AuthLogin', method: 'post' },
     //获取验证码
     get_ValidCode: { url: '/Code/GetValidCode', method: 'get' },
     //24位数码查询
     get_ConsumersScanProductInfo: { url: '/Code/GetConsumersScanProductInfo', method: 'post' },
}, config.pgyerApiUrl);